
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M32.79 58.85l-31.29-.2.07-9.91 27.21.18M11.218 14.978l18.34.112-.037 5.95-18.34-.112zM3.8 48.63a19.26 19.26 0 014-10.88c4-4.93 6-8.88 6.06-15.82M28.61 32.34c-1.75-2.94-1.85-6.08-1.82-10.34M26 14.77a7.94 7.94 0 10-11.21-.16"}}),_c('rect',{attrs:{"x":"28.56","y":"28.91","width":"29.87","height":"29.87","rx":"3.32","transform":"rotate(-.33 43.28 43.53)","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"49.8","cy":"37.48","r":"2.72","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"49.87","cy":"50.15","r":"2.72","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"37.12","cy":"37.55","r":"2.72","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"37.2","cy":"50.22","r":"2.72","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    